import React from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { BsGithub, BsBoxArrowUpRight } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function ProjectCard(props) {
  const navigate = useNavigate();

  const screenshots = [
    ...(props.authshots || []),
    ...(props.thdcScreenshots || []),
    ...(props.paymentshots || []),
    ...(props.swayshots || []),
    ...(props.occshots || []),
    ...(props.paintshots || []),
    ...(props.allnoorshots || []),
    ...(props.flashshots || []),
    ...(props.aiquran || []),
    ...(props.noteiq || []),
    ...(props.plantaidr || []),
    ...(props.faceshots || []),
    ...(props.hairsrshots || []),
  ].filter(Boolean);

  const handleViewProject = () => {
    navigate('/project-detail', {
      state: {
        title: props.title,
        description: props.description,
        imgPath: props.imgPath,
        ghLink: props.ghLink,
        screenshots,
        techStack: props.techStack || [],
      },
    });
  };

  return (
    <Card className="project-card-view">
      <div className="project-img-wrapper">
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <div className="project-overlay">
          <Button
            variant="primary"
            onClick={handleViewProject}
            className="view-project-btn"
          >
            <BsBoxArrowUpRight /> View Project
          </Button>
        </div>
      </div>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <Button
          variant="primary"
          onClick={() => {
            if (!props.ghLink) {
              alert("⚠️ Confidentiality Issue: Source code cannot be shared.");
            } else {
              window.open(props.ghLink, "_blank");
            }
          }}
          className="mb-2"
          style={{ minWidth: "150px" }}
        >
          <BsGithub /> GitHub
        </Button>
      </Card.Body>
    </Card>
  );
}

ProjectCard.propTypes = {
  imgPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isBlog: PropTypes.bool.isRequired,
  ghLink: PropTypes.string,
  demoLink: PropTypes.string,
  techStack: PropTypes.array,
  authshots: PropTypes.array,
  thdcScreenshots: PropTypes.array,
  paymentshots: PropTypes.array,
  swayshots: PropTypes.array,
  occshots: PropTypes.array,
  paintshots: PropTypes.array,
  allnoorshots: PropTypes.array,
  flashshots: PropTypes.array,
  plantaidr: PropTypes.array,
  aiquran: PropTypes.array,
  noteiq: PropTypes.array,
  faceshots: PropTypes.array,
  hairsrshots: PropTypes.array,
};

ProjectCard.defaultProps = {
  techStack: [],
  authshots: [],
  thdcScreenshots: [],
  paymentshots: [],
  swayshots: [],
  occshots: [],
  paintshots: [],
  allnoorshots: [],
  flashshots: [],
  plantaidr: [],
  aiquran: [],
  noteiq: [],
  faceshots: [],
  hairsrshots: [],
};

export default ProjectCard;
